export var Plan;
(function (Plan) {
    Plan["MEMBERSHIP"] = "Membership";
    Plan["PER_PICKUP"] = "PerPickup";
})(Plan || (Plan = {}));
//# sourceMappingURL=pickups.js.map